import { useTranslation } from "react-i18next";
import Dialog from "src/components/Dialog";
import { ReactComponent as DeleteOutlinedIcon } from "./delete-outlined.svg";

export default function RemoveFamilyDeviceDialog({
  isOpen,
  onDismiss,
  onRemove,
  deviceName = ""
}) {
  const { t } = useTranslation();
  return (
    <Dialog
      type="warning"
      icon={DeleteOutlinedIcon}
      isOpen={isOpen}
      heading={t("pairedDevices.removeDeviceDialog.heading", {
        value0: deviceName
      })}
      text={t("pairedDevices.removeFamilyDeviceDialog.text")}
      buttons={[
        {
          text: t("buttons.cancel"),
          onClick: onDismiss
        },
        {
          text: t("buttons.delete"),
          onClick: onRemove
        }
      ]}
    />
  );
}
